import { DataAttribute, type Props } from '../DataAttribute/DataAttribute';
import { Grid, GridItem } from './styles';

type Item = Props & {
  fullRow?: boolean;
};

export const DataAttributeList = ({ dataPoints }: { dataPoints: Item[] }) => {
  return (
    <Grid>
      {dataPoints.map((dataPoint) => (
        <GridItem key={dataPoint.title} fullRow={dataPoint.fullRow || false}>
          <DataAttribute icon={dataPoint.icon} subtitle={dataPoint.subtitle} title={dataPoint.title} />
        </GridItem>
      ))}
    </Grid>
  );
};
